import { DataSource } from '@n7-frontend/core';
import { IChartData } from '@n7-frontend/components';
import { Utils } from './utils';
export class CgrP4DS extends DataSource {
  protected transform(data): IChartData {
    if (!data || !data.userData.cervedIndicators || !data.userData.cervedIndicators || !data.userData.cervedIndicators) {
      return;
    }

    const cgrP4 = data.userData.cervedIndicators.cgrP4;
    const values = !!cgrP4 && !!cgrP4.value ? [cgrP4.value] : [];
    const labels = !!cgrP4 && !!cgrP4.label ? [cgrP4.label] : []; 
    if (!values.length) {
      return {
        containerId: null,
        libOptions: null,
        payload: { loaded: true }
      };
    }

    const chartOption = {
      series: values,
      chart: {
        id: 'cgrp4-chart',
        type: 'radialBar',
        offsetY: -20,
        sparkline: {
          enabled: true
        }
      },
      plotOptions: {
        radialBar: {
          startAngle: -120,
          endAngle: 120,
           hollow: {
            margin: 0,
            size: '70%',
            background: '#fff',
            position: 'front',
            dropShadow: {
              enabled: false
            }
          },
          track: {
            background: '#f4f4f4',
            strokeWidth: '90%',
            margin: 0, // margin is in pixels
            dropShadow: {
              enabled: false
            }
          },
          dataLabels: {
            name: {
              fontSize: '15px',
              fontFamily: 'Open Sans',
              color: '#111',
              offsetY: 96
            },
            value: {
              offsetY: 50,
              fontSize: '28px',
              fontFamily: 'Open Sans',
              fontWeight: 'bold',
              color: '#111',
              formatter: function (val) {
                return ;
              }
            }
          }
        }
      },
      fill: {
        type: 'image',
        image: {
          src: ['../../../assets/images/chart-bg.png'],
        }
      },
      stroke: {
        dashArray: 3
      },
      labels: labels,
      noData: {
        text: 'Dato non disponibile',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#474747',
          fontSize: '14px',
          fontFamily: 'Open Sans'
        }
      }
    }
    return {
      containerId: 'cgrp4-chart',
      libOptions: chartOption,
      payload: { loaded: true }
    };

  }
}
